import { ValidLanguage } from '@/utils/languageResolver';

// `code` is the URL path slug (kept stable for SEO continuity).
// `hreflang` is the geo/language signal emitted to search engines and `<html lang>`.
export const languageOptions = [
  { code: 'en-us' as ValidLanguage, hreflang: 'en-HK', name: 'English', flag: '🇺🇸' },
  { code: 'zh-cn' as ValidLanguage, hreflang: 'zh-CN', name: '简体中文', flag: '🇨🇳' },
  { code: 'zh-hk' as ValidLanguage, hreflang: 'zh-HK', name: '繁體中文', flag: '🇭🇰' },
];

export interface LanguageOption {
  code: ValidLanguage;
  hreflang: string;
  name: string;
  flag: string;
}

export const locales = languageOptions.map((lang) => lang.code);

export function getHreflang(code: string): string {
  return languageOptions.find((o) => o.code === code)?.hreflang ?? code;
}
